import { useHistory } from 'react-router-dom'
import Row, { RowBetween } from 'components/Layout/Row'
import { useTranslation } from 'contexts/Localization'
import { Flex, Text, LinkButton, IconButton, HelpWithQuestionmark } from 'vvs-uikit'
import { Path } from 'config/constants/paths'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import DashboardBox from 'views/VvsGotchi/components/DashboardBox'
import GachaponButton from 'views/VvsGotchi/Gachapon/Btn'
import { ExpeditionTeamMiniRow } from '../ExpeditionTeamRow'
import QuestStatItem from '../QuestStatItem'
import { BestExpBadge } from './BestExpBadge'
import { AccomplishmentRow } from './styles'

const QuestDashboardSection = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { owner: gotchiUser } = useGotchiOwner()

  return (
    <Flex flexDirection="column" m={3}>
      <RowBetween>
        <Flex alignItems="center">
          <Text color="darkestNightBlue" bold fontSize={20}>
            {t('Quests')}
          </Text>
          <IconButton variant="text" onClick={() => history.push(Path.VVS_GOTCHI_QUEST_FAQ)}>
            <HelpWithQuestionmark width="28px" height="28px" />
          </IconButton>
        </Flex>
        <GachaponButton />
      </RowBetween>
      <PixelatedImage
        src="/images/vvsGotchi/mole_exercise.png"
        alt="mole exercise"
        mt={2}
        mb="-1px"
        width="115px"
        alignSelf="center"
        whenRetina
      />
      <Row>
        <DashboardBox>
          <RowBetween mt={2} mb="12px">
            <Text fontSize="13px" color="black">
              {t('Today’s accomplishment')}
            </Text>
            <LinkButton fontSize="13px" fontWeight="700" onClick={() => history.push(Path.VVS_GOTCHI_QUEST_HISTORY)}>
              {t('History')}
            </LinkButton>
          </RowBetween>
          <AccomplishmentRow>
            <QuestStatItem
              type="quest"
              value={gotchiUser?.todayQuestCount ?? 0}
              borderRight="2px lightgray solid"
              pr={4}
              tooltip={t('Number of quests completed today')}
            />
            <QuestStatItem
              type="exp"
              value={gotchiUser?.todayExp ?? 0}
              pl={4}
              pr={2}
              tooltip={t('Total EXP earned today (per Mole)')}
            />
            <BestExpBadge value={gotchiUser?.highestDayExp ?? 0} />
          </AccomplishmentRow>
          <RowBetween mt={3}>
            <Text fontSize="13px" color="darkestNightBlue">
              {t('Team on Quests')}
            </Text>
            <LinkButton fontSize="13px" fontWeight="700" onClick={() => history.push(Path.VVS_GOTCHI_TEAM)}>
              {t('Manage Team')}
            </LinkButton>
          </RowBetween>
          <ExpeditionTeamMiniRow />
          <RowBetween mt={3}>
            <Text fontSize="13px" color="darkestNightBlue">
              {t('EXP boost based on team’s health')}
            </Text>
            <LinkButton
              fontSize="13px"
              fontWeight="700"
              onClick={() => history.push(Path.VVS_GOTCHI_QUEST_FAQ, { focus: 'teamHealth' })}
            >
              {t('What is this?')}
            </LinkButton>
          </RowBetween>

          <ExpBoost expMultiplier={gotchiUser?.expMultiplier} />
        </DashboardBox>
      </Row>
    </Flex>
  )
}

export default QuestDashboardSection

const ExpBoost = ({ expMultiplier }: { expMultiplier: number }) => {
  const { t } = useTranslation()

  if (typeof expMultiplier !== 'number') {
    return (
      <Text fontSize="28px" color="darkGrey" fontWeight="600">
        {t('N/A')}
      </Text>
    )
  }

  const color = expMultiplier > 1 ? 'success' : expMultiplier < 1 ? 'failure' : 'black'

  return (
    <Text fontSize="28px" color={color} fontWeight="600">
      {expMultiplier >= 1 ? '+ ' : '- '}
      {Math.abs((expMultiplier - 1) * 100).toFixed(0)}%
    </Text>
  )
}
